import { BasicarticleEditorComponent } from './../basicarticle-editor/basicarticle-editor.component';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { HttpService } from '@sdbn/appclient';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { DialogService } from '@sdbn/appclient';
import { ArticleType, ArticleTypeAttributeType, BasicArticleDefinitionAttribute } from 'src/erp-articles/article-types/article-type.model';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { environment } from 'src/environments/environment';
import { BasicArticle } from '../basicarticle.model';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-basicarticle-admin',
  templateUrl: './basicarticle-admin.component.html',
  styleUrls: ['./basicarticle-admin.component.scss']
})
export class BasicArticleAdminComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  articleTypes = new Array<ArticleType>();
  selectedArticleType: ArticleType = null;
  subscription: Subscription;

  basicArticlesForSelectedArticleType = new Array<BasicArticle>();

  /** Table settings */
  columnNames = new Array<string>();
  columnIds = new Array<string>();
  datasource = new MatTableDataSource<any>();

  formGroup = new FormGroup({});

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private dialogService: DialogService,
    private articleTypeService: ArticleTypeService,
    private http: HttpService,
    public translationService: TranslationService) {
      super();
      this.formGroup.addControl('articleTypeControl', new FormControl(null, []));
      // Initial receive of articletypes. Handles Deep Link behavior, if app is reloaded and module is this
      this.subscription = this.articleTypeService.changed$.subscribe(() => {
        this.subscription.unsubscribe();
        this.loadAvailableArticleTypes();
        if (this.articleTypes != null && this.articleTypes.length > 0) {
          this.selectedArticleType = this.articleTypes[0];
          this.formGroup.controls.articleTypeControl.setValue(this.selectedArticleType);
          this.loadBasicArticlesByArticleType();
        }
      });
    }


  ngOnInit(): void {

    this.loadAvailableArticleTypes();
    if (this.articleTypes != null && this.articleTypes.length > 0) {
      this.selectedArticleType = this.articleTypes[0];
      this.formGroup.controls.articleTypeControl.setValue(this.selectedArticleType);
      this.loadBasicArticlesByArticleType();
    }
    this.formGroup.valueChanges.subscribe(formValues => {
      this.selectedArticleType = formValues.articleTypeControl;
      if (this.selectedArticleType != null) {
        this.loadBasicArticlesByArticleType();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onCreateNewBasicArticle() {
    this.openBasicArticleEditor(this.selectedArticleType);
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: any) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  editBasicArticle(basicArticle: BasicArticle): void {
    const articleType = this.articleTypeService.getById(basicArticle.articleTypeId).completeArticleType;
    this.dialogService.openLarge(BasicarticleEditorComponent, {articleType: articleType, basicArticle: basicArticle}).afterClosed().subscribe(result => {
      this.loadBasicArticlesByArticleType();
    });
  }

  private openBasicArticleEditor(articleType: ArticleType): void {
    this.dialogService.openLarge(BasicarticleEditorComponent, {articleType: articleType}).afterClosed().subscribe(result => {
      this.loadBasicArticlesByArticleType();
    });
  }

  private loadAvailableArticleTypes(): void {
    this.articleTypes = this.articleTypeService.articleTypes;
  }

  private loadBasicArticlesByArticleType(): void {
    this.http.postWithContext<Array<BasicArticle>>(environment.erpBasicArticleEndpoint + '/getAllBasicArticles', {}).subscribe(response => {
      const loadedBasicArticles = new Array<BasicArticle>();
      if (response != null) {
        for (const basicArticle of response) {
          const ba = new BasicArticle(basicArticle);
          if (ba.articleTypeId === this.selectedArticleType?.id) {
            loadedBasicArticles.push(ba);
          }
        }
      }
      this.basicArticlesForSelectedArticleType = loadedBasicArticles;
      this.updateBasicArticleTable(loadedBasicArticles);
      }, error => {
        console.log('error is', error);
        this.updateBasicArticleTable(new Array<BasicArticle>());
      });
  }

  private updateBasicArticleTable(basicArticles: Array<BasicArticle>): void {
    // Use first BasicArticle to build displayedColumns
    const displayedColumns = new Array<string>();
    const data = new Array<any>();
    this.sortAttributes(this.selectedArticleType);
    if (this.selectedArticleType != null && this.selectedArticleType.completeArticleType.basicArticleDefinition != null) {
      for (const attribute of this.selectedArticleType.completeArticleType.basicArticleDefinition?.attributes) {
        displayedColumns.push(attribute.articleTypeAttribute.name.getValue(this.translationService.language).value);
      }
      for (const basicArticle of basicArticles) {
        const tableDataEntry = {basicArticle: basicArticle};
        for (const attribute of this.selectedArticleType.completeArticleType.basicArticleDefinition.attributes) {
          if (attribute.articleTypeAttribute != null) {
            const attributeName = attribute.articleTypeAttribute.name.getValue(this.translationService.language).value;
            tableDataEntry[attributeName + ''] = this.resolveAttributeTextValue(attribute, basicArticle);
          }
        }
        data.push(tableDataEntry);
      }
      displayedColumns.push('actions');
    }
    this.columnNames = displayedColumns;
    this.datasource = new MatTableDataSource(data);

  }

  private resolveAttributeTextValue(attribute: BasicArticleDefinitionAttribute, basicArticle: BasicArticle): string {
    const basicarticleAttributeValue = basicArticle.getValueByAttributeId(attribute.attributeId);
    if (basicarticleAttributeValue == null) {
      return null;
    }
    const attributeValue = basicarticleAttributeValue.value;
    if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.BOOLEAN) {
      return attributeValue;
    } else if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.DATE) {
      return attributeValue;
    } else if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.DECIMAL) {
      return attributeValue;
    } else if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.LOOKUP) {
      for (const selectOption of attribute.articleTypeAttribute.values) {
        if ('' + selectOption.id === attributeValue) {
          return selectOption.value;
        }
      }
    } else if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.NUMBER) {
      return attributeValue;
    } else if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.STRING) {
      return attributeValue;
    } else if (attribute.articleTypeAttribute.type === ArticleTypeAttributeType.TEXT) {
      return attributeValue;
    }
  }

  private sortAttributes(articleType: ArticleType) {
    articleType.basicArticleDefinition.attributes.sort( (a, b) => {
      if (a == null || a.articleTypeAttribute == null || a.articleTypeAttribute.sortValue == null) {
        return -1;
      }
      if (b == null || b.articleTypeAttribute == null || b.articleTypeAttribute.sortValue == null) {
        return 1;
      }
      return a.articleTypeAttribute.sortValue.localeCompare(b.articleTypeAttribute.sortValue);
    });
  }

}
